import { render, staticRenderFns } from "./RecentlyVisitPatient.vue?vue&type=template&id=05c012d8"
import script from "./RecentlyVisitPatient.vue?vue&type=script&lang=js"
export * from "./RecentlyVisitPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports